import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Sprout, Target, Users, TrendingUp } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const programs = [{
  title: 'Agriculture Cluster Development Project (ACDP)',
  description: 'Aims to raise on-farm productivity, production, and marketable volumes of selected agricultural commodities in specified geographic clusters.',
  icon: Sprout
}, {
  title: 'Operation Wealth Creation (OWC)',
  description: 'Intervention to facilitate effective national socio-economic transformation with a focus on raising household incomes and wealth creation.',
  icon: Target
}, {
  title: 'Parish Development Model (PDM)',
  description: 'Agriculture component focusing on increasing production and productivity across the entire value chain at the parish level.',
  icon: Users
}, {
  title: 'National Agricultural Extension Strategy (NAES)',
  description: 'Empowering farmers through effective extension services to adopt improved technologies and practices.',
  icon: TrendingUp
}];
export function ProgramsPage() {
  return <>
      <Header data-id="element-1356" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1357">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1358">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1592982537447-6f2a6a0c7c18?w=1600&h=600&fit=crop")'
        }} data-id="element-1359"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1360"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1361">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1362">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1363">
                <Home className="w-4 h-4 mr-1" data-id="element-1364" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1365" />
              <span data-id="element-1366">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1367" />
              <span className="text-white font-medium" data-id="element-1368">Programs</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1369">
              MAAIF Programs
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1370">
              Overview of key national programs driving agricultural
              transformation, wealth creation, and food security in Uganda.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-1371">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1372">
            {programs.map((program, index) => {
            const Icon = program.icon;
            return <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-1373">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-6" data-id="element-1374">
                    <Icon className="w-6 h-6" data-id="element-1375" />
                  </div>
                  <h3 className="text-xl font-bold text-uganda-black mb-3" data-id="element-1376">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1377">
                    {program.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-1378" />
    </>;
}